import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
const StyledButton = styled(Button)({
  textTransform: "none",
});
const MyButton = ({ children, ...otherProp }) => {
  return <StyledButton {...otherProp}>{children} </StyledButton>;
};
export default MyButton;
